class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');
    this.suggestions = null;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.input.addEventListener('focus', () => {
      if (!this.input.value.trim().length) this.showSuggestions();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.showSuggestions();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  showSuggestions() {
    if (this.suggestions) {
      this.predictiveSearchResults.innerHTML = this.suggestions;
      this.show();
      return;
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=an-suggestions')
      .then((r) => (r.ok ? r.text() : ''))
      .then((text) => {
        const el = new DOMParser().parseFromString(text, 'text/html').querySelector('.an-sugg');
        if (!el) return;
        this.suggestions = el.outerHTML;
        if (!this.input.value.trim().length) {
          this.predictiveSearchResults.innerHTML = this.suggestions;
          this.show();
        }
      })
      .catch(() => {});
  }

  getSearchResults(searchTerm) {
    fetch(Theme.routes.predictive_search_url + `?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,collection,page,article`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.show();
      })
      .catch((error) => {
        this.hide();
        throw error;
      });
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
